<template>
    <div class="page course-page mx-md-auto">
        <v-container class="pb-0" :class="{'pa-0': phoneOnly}">
            <div v-if="loading">

            </div>
            <div v-else-if="lecture">
                <div v-if="lecture.image_url" class="pa-5 pb-2">
                    <v-img :src="lecture.image_url" :height="pcOnly ? 400 : 220" max-width="700" class="rounded-lg mx-auto" />
                </div>

                
                <div class="px-5 medium-text">
                    <div class="rounded mb-2 mt-5 strong-text--text text-center" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 21px;">
                    {{lecture.name}}
                    </div>
                    <div v-if="lecture.description" class="mb-4">
                        <span v-if="lecture.description.length < maxDescriptionLength" v-html="urlify(escapeHtmlText(lecture.description))"></span>
                        <div v-else style="line-height: 1.5; white-space: pre-line;" class="details-text text--text">
                            <span v-html="urlify(escapeHtmlText(showMoreDescription ? lecture.description : lecture.description.slice(0, maxDescriptionLength)))"></span><span v-if="!showMoreDescription">...</span>

                            <a v-ripple v-if="!showMoreDescription" text class="link--text d-inline-block ms-1" @click="showMoreDescription = true" style="white-space: nowrap">عرض المزيد</a>
                            <a v-ripple v-else text class="link--text d-inline-block ms-2" @click="showMoreDescription = false" style="white-space: nowrap">عرض أقل</a>
                        </div>
                        
                    </div>
                </div>

                <v-divider class="mt-4"></v-divider>
                <v-tabs v-model="activeTab" color="primary" light grow class="px-0 mx-0 rounded">
                    <v-tab v-haptic href="#videosTab" style="letter-spacing: 0">
                        <v-icon right>mdi-view-list-outline</v-icon>
                        محتويات المحاضرة
                    </v-tab>
                    <!-- <v-tab v-haptic href="#descriptionTab" style="letter-spacing: 0">
                        <v-icon right>mdi-text</v-icon>
                        الوصف
                    </v-tab> -->
                </v-tabs>
                <v-divider></v-divider>

                <div class="strong-text--text mt-3 px-0" :style="bottomSafeArea ? `padding-bottom: ${bottomSafeInsetPx}px;` : ''">
                    <v-tabs-items v-model="activeTab" class="mb-4">
                        <v-tab-item value="videosTab">

                            <v-alert v-if="platform === 'web' && !miniDerasaPlatform && !wpEnabled" text dark color="primary" class="blink-animation" :class="phoneOnly ? 'ma-3 pa-4' : 'mb-3 px-5 py-3'">
                                <div class="d-flex align-center" :class="{'flex-column justify-center': phoneOnly, 'justify-space-between': pcOnly}">
                                    <div :class="{'text-center': phoneOnly}">
                                        قم بتحميل {{phoneOnly ? 'تطبيق الهاتف' : 'برنامج الديسكتوب'}} حتى تتمكن من مشاهدة المحاضرات
                                    </div>

                                    <div :class="{'ms-4': pcOnly, 'mt-2': phoneOnly}">
                                        <v-btn v-if="pcOnly" depressed :block="phoneOnly" color="primary" tag="a" download :href="appData.desktop_app_url">
                                            <v-icon size="20" class="ml-2" color="white">mdi-monitor</v-icon>
                                            تحميل البرنامج
                                        </v-btn>

                                        <div v-else class="store-badges d-flex align-center justify-start pa-0">
                                            <store-badge type="playstore" width="135px" />
                                            <store-badge type="appstore" width="106px" />
                                        </div>

                                    </div>
                                </div>
                            </v-alert>
                            
                            <!-- <v-alert v-if="!lecture.enable_videos" text dense outlined type="error" icon="mdi-clipboard-text" color="error" class="medium-text font-weight-bold e-link mx-4" v-ripple @click="activeTab = 'examsTab'">
                                لديك امتحانات إجبارية قبل فتح الفيديوهات
                            </v-alert> -->

                            <v-expansion-panels
                                v-if="collections && collections.length"
                                flat
                                class="transparent mb-2"
                            >
                                <v-expansion-panel
                                    v-for="collection in collections"
                                    :key="collection.id"
                                    class="transparent mb-md-3 pa-1 bordered lecture-collection-panel"
                                    :class="{'rounded-lg': pcOnly}"
                                    :style="phoneOnly ? 'border-radius: 0!important;' : ''"
                                >
                                    <v-expansion-panel-header class="px-4 py-2" v-ripple="{class: 'ripple--color'}">
                                        <div class="d-flex align-start">
                                            <div>
                                                <v-icon color="primary" class="me-2">mdi-folder</v-icon>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="strong-text--text text-truncate" style="line-height: 1.5!important;">{{ collection.name }}</div>
                                                <div v-if="collection.items && collection.items.length" class="small-text muted--text">{{unitFormat(collection.items.length, 'عنصر', 'عنصرين', 'عناصر')}}</div>
                                                <div v-else class="small-text muted--text">فارغ</div>
                                            </div>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="pa-0">
                                        <lecture-contents-list
                                            v-if="collection.items && collection.items.length"
                                            :items="collection.items"
                                            :lecture="lecture"
                                            :opening-exam="openingExam"
                                            hide-attachments
                                            attendance-chip-placement="subtitle"
                                            @play-video="(video, idx) => playVideo(video, idx, collection.items)"
                                            @open-exam="openExam"
                                        />
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <div v-if="items && items.length">
                                <v-subheader style="height: auto!important" class="mt-5">
                                    عناصر أخرى
                                </v-subheader>
                                <lecture-contents-list
                                    :items="items"
                                    :attachments="attachments"
                                    :lecture="lecture"
                                    :opening-exam="openingExam"
                                    attendance-chip-placement="subtitle"
                                    @play-video="playVideo"
                                    @open-exam="openExam"
                                />
                            </div>
                        </v-tab-item>
                        <!-- <v-tab-item value="descriptionTab" class="px-6">
                            <div style="line-height: 2.2; white-space: pre-line;" class="medium-text text--text">{{lecture.description}}</div>
                        </v-tab-item> -->
                    </v-tabs-items>
                </div>
            </div>


            <v-dialog v-model="phoneDownloadDialog" max-width="400" overlay-color="#000" overlay-opacity="0.8">
                <v-card>
                    <v-card-title class="mb-2">حمل تطبيق الهاتف</v-card-title>
                    <v-card-subtitle>لكي تتمكن من مشاهدة المحاضرة؛ يجب عليك تحميل تطبيق الهاتف</v-card-subtitle>
                    <v-card-text>
                    
                        <div class="d-flex justify-center align-center">
                            <store-badge type="playstore" width="150px" />
                            <store-badge type="appstore" width="120px" />
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <video-dialog v-model="showVideoDialog" :video="showVideo" :next="nextVideo" :previous="previousVideo" @playNext="playVideo(nextVideo, nextVideoIndex, videoDialogItemList)" @playPrevious="playVideo(previousVideo, previousVideoIndex, videoDialogItemList)" />
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import VideoDialog from '@/components/custom/video-dialog'
import LectureContentsList from '@/components/custom/lecture-contents-list'
import StoreBadge from '@/components/default/store-badge'

import { PrivacyScreen } from '@capacitor-community/privacy-screen';

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

export default {
    name: "Courses",
    components: {
        StoreBadge,
        VideoDialog,
        LectureContentsList,
    },
    props: {
        
    },
    data(){
        return {
            lecture: null,

            activeTab: '',
            show: false,
            loading: false,

            videos: null,
            items: null,
            collections: null,
            exams: null,
            attachments: null,

            showMoreDescription: false,

            phoneDownloadDialog: false,

            showVideoDialog: false,
            showVideo: null,
            nextVideo: null,
            nextVideoIndex: null,

            previousVideo: null,
            previousVideoIndex: null,

            openingExam: false,

            /** List containing the current video (root `items` or a collection's `items`) for next/prev in the player */
            videoDialogItemList: null,
            
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        maxDescriptionLength(){
            return this.pcOnly ? 350 : 200;
        },

        loadingSpinner(){
            return this.openingExam;
        },
        examsBadge(){
            let count = 0;
            const exams = this.exams ? this.exams : [];
            exams.forEach(exam=>{
                if (exam.needs_attention){
                    count += 1;
                }
            })
            return count;
        },
    },
    methods: {
        ...GlobalMethods,

        playVideo(video, i, itemList){
            const list = itemList || this.items;
            this.videoDialogItemList = list;
            this.show = false;
            let wpEnabled = this.wpEnabled;

            if (this.platform === 'web' && !wpEnabled && !this.miniDerasaPlatform){
                if (this.pcOnly){
                    const apiToken = window.localStorage.getItem('tK'); // user oauth token
                    const deepLinkProtocol = process.env.VUE_APP_DESKTOP_APP_PROTOCOL;
                    const url = `${deepLinkProtocol}://video?videoId=${video.id}&token=${apiToken}`
                    window.open(url, '_self')
                }else{
                    // on phone, open download-phone-app dialog
                    this.phoneDownloadDialog = true;
                }
            }else if (this.platform === 'android' || this.platform === 'ios' || this.miniDerasaPlatform || wpEnabled){
                window.setTimeout(()=>{
                    this.showVideoDialog = true;
                    this.showVideo = video;
                    
                    this.nextVideo = null;
                    this.nextVideoIndex = null;
                    this.previousVideo = null;
                    this.previousVideoIndex = null;

                    if (list && i + 1 < list.length){
                        const nextItem = list[i + 1];
                        if (nextItem.type === 'video' && !nextItem.locked){
                            this.nextVideo = nextItem.item;
                            this.nextVideoIndex = i + 1;
                        }
                    }
                    if (list && i - 1 >= 0){
                        const previousItem = list[i - 1];
                        if (previousItem.type === 'video' && !previousItem.locked){
                            this.previousVideo = previousItem.item;
                            this.previousVideoIndex = i - 1;
                        }
                    }
                }, 200);
            }
        },
        isWebIOS(){
            if (this.capRunning){
                return false
            }
            var isIOS = /iPad|iPhone|iPod|webOS/.test(navigator.userAgent);
            return isIOS;
        },

        openExam(exam){
            const exam_code = exam.navigate_to_alternative && exam.alternative_exam ? exam.alternative_exam.exam_code : exam.exam_code;
            // get exam details
            if (!this.openingExam){
                this.openingExam = true;
                window.axios.get(`/exams/details?exam_code=${exam_code}`).then(response=>{
                    this.openingExam = false;
                    this.show = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}, query: {course_id: this.lecture.course_id}})
                    }, 600);

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الامتحان غير موجود', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.openingExam = false;
                })
            }
        },

        loadData(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/lectures/${this.id}/contents`).then(response=>{
                    this.setDRM();

                    this.loading = false;
                    this.videos = response.data.videos;
                    this.lecture = response.data.lecture;
                    this.items = response.data.items;
                    this.collections = response.data.collections;
                    this.exams = response.data.exams;
                    this.attachments = response.data.attachments;
                    this.videosDialog = true;

                    this.setDocumentTitle(this.lecture.name, true);
                }).catch(e=>{
                    this.loading = false;
                    if (e.response && e.response.data && e.response.data.course_id){
                        this.$router.push({name: 'course', params: {id: e.response.data.course_id}});
                        this.showMsg('يتعين عليك شراء المحاضرة أولاً', 'error');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                    }
                })
            }
        },

        setDRM(){
            if (this.platform === 'android'){
                return PrivacyScreen.enable();
            }
        },
        removeDRM(){
            if (this.platform === 'android'){
                return PrivacyScreen.disable();
            }
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        backButtonHandler(){
            if (this.showVideoDialog){
                this.showVideoDialog = false;
            }else{
                this.$router.push({name: 'course', params: {id: this.lecture.course_id}});
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        showVideoDialog(show){
            if (!show){
                this.loadData();
            }
        },
    },
    mounted(){
        if (this.appData && this.appData.lectures_view_layout !== 'seperated'){
            this.$router.push('/not-found');
        }
        this.loadData();

        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    beforeDestroy(){
        this.removeDRM();
        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler);
        }
    }
};
</script>

<style lang="scss" scoped>
    @media(max-width: 960px){
        h1{
            line-height: 1.3;
            font-size: 1.8rem;
            font-weight: bold!important;
            text-align: center;
        }
    }
    @media(min-width: 960px){
        .header{
            .container{
                min-height: 270px;
            }
        }
    }
</style>
<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
.lecture-collection-panel{
    .v-expansion-panel-content__wrap{
        padding: 0!important;
    }

    &.v-expansion-panel--active:not(:first-child), &.v-expansion-panel--active + .v-expansion-panel{
        margin-top: 0;
        
    }
}
</style>
